
































































import { Component, Vue } from 'vue-property-decorator'
import { openAddTodo } from '@/api/open/todo'
import { patchAddTodo } from '@/api/todo'
import { GROUP_ID, TOKEN } from '@/constant/storageConstant'
import { priorities, todoGroupList, todoGroupPriorities, todoList } from '@/constant/todoConstant'
import moment from 'moment'
import { handleTodoList } from '@/utils/todo'

@Component({
  name: 'TodoNav'
})
export default class extends Vue {
  private isTodoGroupList = true
  private isOpen = false
  private isClearAdd = true
  private tokenStr: string | undefined
  private todoFormVisible = false
  private addLoading = false
  private todoForm: any = {}
  private priorities = priorities
  private todoGroupPriorities = todoGroupPriorities

  private handleAdd () {
    const token = localStorage.getItem(TOKEN)
    const groupId = localStorage.getItem(GROUP_ID)
    // 清空
    if (this.isClearAdd) {
      this.todoForm = {}
    }
    if (groupId !== null) {
      this.todoForm.groupId = groupId
    }
    this.isTodoGroupList = this.$route.path === '/todoGroupList'
    if (token !== null) {
      this.isOpen = true
      this.tokenStr = token
    }
    this.todoFormVisible = true
  }

  private checkParam (v: any) {
    if (v === undefined) {
      return false
    }

    if (this.isTodoGroupList) {
      if (v.maxTime === undefined ||
        v.minPriority === undefined) {
        return false
      }
    } else {
      if (v.groupId === undefined) {
        return false
      }
    }

    if (this.isOpen) {
      if (v.task === undefined ||
        v.priority === undefined) {
        return false
      }
    } else {
      if (v.task === undefined ||
        v.value === undefined ||
        v.estimateTime === undefined ||
        v.priority === undefined) {
        return false
      }
    }
    return true
  }

  private changeIsClearAdd (status: any) {
    this.isClearAdd = status
  }

  private async submitAdd () {
    if (!this.checkParam(this.todoForm)) {
      this.$message.error('请填写完任务信息')
      return
    }

    this.addLoading = true
    if (this.isTodoGroupList) {
      const param = {
        maxTime: this.todoForm.maxTime,
        minPriority: this.todoForm.minPriority,
        todoList: [{
          task: this.todoForm.task,
          value: this.todoForm.value,
          estimateTime: this.todoForm.estimateTime,
          priority: this.todoForm.priority
        }]
      }
      const result = await patchAddTodo(param)
      this.changeIsClearAdd(result.status)
      if (result.status) {
        const t = result.data
        const todoGroup = {
          id: t.id,
          createTime: t.createTime,
          totalValue: t.value,
          finishValue: t.finishValue,
          totalTime: t.totalTime,
          maxTime: t.maxTime,
          minPriority: t.minPriority,
          updateDateTime: moment(t.updateTime).format('YYYY-MM-DD HH:mm:ss'),
          status: t.status
        }
        todoGroupList.unshift(todoGroup)
        this.$message.success('添加成功')
      }
    } else {
      if (this.isOpen) {
        if (this.tokenStr === undefined) {
          this.$message.error('你无权操作')
          return
        }
        const result = await openAddTodo(this.tokenStr, {
          task: this.todoForm.task,
          priority: this.todoForm.priority
        })
        if (result.status) {
          this.$message.success('添加成功')
        }
        this.changeIsClearAdd(result.status)
        handleTodoList(result, todoList, true)
      } else {
        const param = {
          groupId: this.todoForm.groupId,
          maxTime: this.todoForm.maxTime,
          minPriority: this.todoForm.minPriority,
          todoList: [{
            task: this.todoForm.task,
            value: this.todoForm.value,
            estimateTime: this.todoForm.estimateTime,
            priority: this.todoForm.priority
          }]
        }
        const result = await patchAddTodo(param)
        if (result.status) {
          this.$message.success('添加成功')
        }
        this.changeIsClearAdd(result.status)
        handleTodoList(result, todoList, true)
      }
    }

    this.todoFormVisible = false
    this.addLoading = false
  }
}
